import { useEffect, useMemo, useState } from "react";
import { filterObjectByKeys, disabledFilterTooltipTitle } from "./DreamSearchFilter";
import debounce from "lodash/debounce";
import { useDreamSearchContext } from "../../../DreamSearchContext";
import { VocationIndustryToName } from "@portal/app/_common/types/vocationIndustry";
import isEmpty from "lodash/isEmpty";
import { EnumMultiSelectChipFilter } from "@portal/app/manage/_components/DreamTable";
import { FilterComponentProps } from "./DreamSearchFilter";
import pick from "lodash/pick";

export const ProgramIndustryFilterComponent = ({
  value,
  setValue,
  setHasOptions,
}: FilterComponentProps<GQL.VocationIndustry[]>) => {
  const { filterSettings } = useDreamSearchContext();
  const [localValue, setLocalValue] = useState<GQL.VocationIndustry[]>(value);

  // Filter out the industries that are not in the filter settings
  // and then sort them to match the order in the friendly map
  const [availableOptions] = useState(
    pick(
      filterObjectByKeys(VocationIndustryToName, filterSettings?.industries),
      Object.keys(VocationIndustryToName)
    )
  );

  const debounceSetValue = useMemo(
    () => debounce((localValue: GQL.VocationIndustry[]) => setValue(localValue), 500),
    [setValue]
  );

  useEffect(() => {
    if (filterSettings) {
      setHasOptions(Object.keys(availableOptions).length > 0);
    }
  }, [availableOptions, filterSettings, setHasOptions]);

  return (
    <EnumMultiSelectChipFilter<GQL.VocationIndustry>
      label="Industry"
      value={localValue}
      id="vocation-industry"
      setValue={(value) => {
        const newValue = isEmpty(value) ? null : value;
        setLocalValue(newValue);
        debounceSetValue(newValue);
      }}
      enumToFriendlyMap={availableOptions}
      disabledTooltipTitle={disabledFilterTooltipTitle}
    />
  );
};
